import React, { useContext, useState, useEffect } from "react";
import { Form, Input, Button, Typography, notification, Drawer, List, Avatar, Spin, Tag } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import GenericTable from "../components/GenericTable";
import { UserOutlined, FileTextOutlined } from '@ant-design/icons';
import axios from "axios";
import { AuthContext } from "../AuthContext";
import GenericModal from "../components/GenericModal ";
import "../App.css";
import AppMenu from "../components/AppMenu";

const { Title, Text } = Typography;

const SuperAdmin = () => {
  const { platform } = useParams();
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState('viewAgents');
  const [inviteModalVisible, setInviteModalVisible] = useState(false);
  const { setAuthToken, setUserDetails, orgData } = useContext(AuthContext);
  const [emails, setEmails] = useState([{ key: Date.now(), value: '' }]);  // Manage multiple emails
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const dummyUsers = [
      { id: '1', name: 'John Doe', email: 'john@example.com', verified: true },
      { id: '2', name: 'Jane Smith', email: 'jane@example.com', verified: false },
      { id: '3', name: 'Alice Johnson', email: 'alice@example.com', verified: true },
      { id: '4', name: 'Bob Brown', email: 'bob@example.com', verified: false },
    ];

    getUsers();
    setUsers(dummyUsers);
    setLoading(false);
  }, []);


  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    console.log("Ok clicked");
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    console.log("Cancel clicked");
    setIsModalVisible(false);
  };

  const footerActions = ["Submit", "Cancel"];
  const footerFunctions = [handleOk, handleCancel];

 // Define inputs for the form (can be dynamic)
 const inputs = [
  { label: "Name", name: "name", type: "text", placeholder: "Enter your name" },
  { label: "Email", name: "email", type: "email", placeholder: "Enter your email" },
  { label: "Age", name: "age", type: "number", placeholder: "Enter your age" },
];

const predefinedData = {
  name: "John Doe",
  email: "john.doe@example.com",
  age: 30,
};

  const data = [
    { id: 1, name: "John Doe", age: 28, job: "Engineer" },
    { id: 2, name: "Jane Smith", age: 34, job: "Designer" },
    { id: 3, name: "Alice Johnson", age: 23, job: "Developer" },
    { id: 4, name: "Bob Brown", age: 45, job: "Manager" },
  ];
  
  // Define action handlers corresponding to each action
  const handleEdit = (record) => {
    console.log("Editing record: ", record);
  };
  
  const handleDelete = (record) => {
    console.log("Deleting record: ", record);
  };

  


  const getUsers = async () => {
    const url = orgData?.role == 'SUPERADMIN' ? `${process.env.REACT_APP_API}/api/organizations/users` : `${process.env.REACT_APP_API}/api/organizations/${orgData.id}/users`
    const response = await axios.get(url)
    setUsers(response.data)

  }

  const handleAddEmail = () => {
    setEmails([...emails, { key: Date.now(), value: '' }]);
  };

  const handleEmailChange = (key, value) => {
    setEmails(emails.map(email => email.key === key ? { ...email, value } : email));
  };

  const handleInviteSubmit = async () => {
    const emailList = emails.map(email => email.value);

    try {
      await axios.post(
        `${process.env.REACT_APP_API}/api/auth/invite/${orgData.id}`,
        {
          emails: emailList,
        }
      );
      notification.success({
        message: 'Invitations Sent Successfully',
      });
      setInviteModalVisible(false);
      setEmails([{ key: Date.now(), value: '' }]);  // Reset emails
    } catch (error) {
      notification.error({
        message: 'Failed to Send Invitations',
        description: error.message,
      });
    }
  };


  return (
    <div style={{ backgroundColor: "#222" }}>
      <AppMenu/>
      <div className="container">
        <div style={{ position: "absolute", top: "20px", right: "20px", cursor: "pointer" }} onClick={() => navigate('/')}>
          Back To Console
        </div>

        <h1 className="title">ZautoAI Leading the AI Revolution</h1>
        <p className="subtitle">Welcome back, Admin! Let's continue making extraordinary progress</p>
        <div><h1>Admin Panel</h1></div>
      </div>
      <div className="admin-panel-container">
        <div className="admin-panel-header">
          <h1 className="admin-panel-title">Users</h1>
          <div className="invite-btn-admin">
            <div className="invite-user-button" onClick={() => setInviteModalVisible(true)}>
              <span className="invite-user-icon">➕</span> Invite User
            </div>
          </div>
        </div>

        {loading ? (
          <Spin size="large" className="user-list-spin" />
        ) : (
          <div className="organization-list">
            {users.map((organization) => (
              <div key={organization.organizationId} className="organization-item">
                <h2 className="organization-name">{organization.organizationName}</h2>
                <List
                  className="user-list"
                  itemLayout="horizontal"
                  dataSource={organization.users}
                  renderItem={(user) => (
                    <List.Item className="user-list-item">
                      <List.Item.Meta
                        className="user-list-item-meta"
                        avatar={
                          <Avatar className="user-avatar" style={{ backgroundColor: '#1890ff' }}>
                            {user.userName[0].toUpperCase()}
                          </Avatar>
                        }
                        title={<span className="user-name">{user.userName}</span>}
                        description={
                          <div className="user-info">
                            <span className="user-email">{user.email}</span>
                            <Tag color={user.verified ? 'green' : 'red'}>{user.verified ? 'Verified' : 'Not Verified'}</Tag>
                            <Tag color={user.status === 'ACTIVE' ? 'green' : 'red'}>{user.status}</Tag>
                            <Tag color={user.role === 'SUPERADMIN' ? 'purple' : user.role === 'ADMIN' ? 'blue' : 'orange'}>{user.role}</Tag>
                          </div>
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      <Drawer
        title="Invite Users"
        placement="right"
        onClose={() => setInviteModalVisible(false)}
        visible={inviteModalVisible}
        width={400}
      >
        <Form layout="vertical" onFinish={handleInviteSubmit}>
          {emails.map((email, index) => (
            <Form.Item key={email.key} label={`User Email ${index + 1}`}>
              <Input
                value={email.value}
                onChange={(e) => handleEmailChange(email.key, e.target.value)}
                placeholder="Enter email address"
              />
            </Form.Item>
          ))}
          <Button type="dashed" onClick={handleAddEmail} style={{ width: '100%', marginBottom: '20px' }}>
            Add Another Email
          </Button>
          <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
            Send Invitations
          </Button>
        </Form>
      </Drawer>

      <div className="app">
      <GenericTable
        data={data}
        searchKeys={["name", "job"]} // Columns that should be searchable
        sortableColumns={["age", "name"]} // Columns that should be sortable
        actions={["delete", "edit"]} // Individual actions
        actionFunctions={[handleDelete, handleEdit]} // Functions corresponding to each action
      />
    </div>

    <div>
      <button onClick={showModal}>Open Form Modal</button>

      <GenericModal
        isVisible={isModalVisible}
        title="Edit User"
        inputs={inputs}
        actions={footerActions}
        actionFunctions={footerFunctions}
        predefinedData={predefinedData} // If it's an edit form
        handleCancel={handleCancel}
      />
    </div>
    </div>
  );
};

export default SuperAdmin;
